import React, { useContext, useEffect, useRef, useState } from 'react';

import {
  MaterialReactTable,
} from "material-react-table";
import { GraduationCapIcon } from 'lucide-react';
import { base_url } from '../../config';
import axios from 'axios';
import StudentProofModal from './StudentProofModal';
import RegistrationContext from '../../contexts/RegistrationContext';

const UserTable = () => {
  const { reloadAdminBadges, setReloadAdminBadges } = useContext(RegistrationContext);
  const [data, setData] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [pdf, setPDF] = useState(null);
  const [rowData, setRowData] = useState(null);
  const skippedRef = useRef(new Set());

  const fetchStudents = async () => {
    try {
      const response = await axios.get(`${base_url}/api/admin/students`);
      return response.data || [];
    } catch (error) {
      console.error('Error fetching students:', error);
      return [];
    }
  };

  const reloadData = async () => {
    const rows = await fetchStudents();
    setData(rows);
    return rows;
  };

  useEffect(() => {
    reloadData();
  }, []);

  const loadStudent = async (row) => {
    try {
      const response = await axios.get(`${base_url}/api/admin/students_pdf`, {
        params: { id: row.student_proof_file_id },
        responseType: 'blob',
      });
      const blob = new Blob([response.data], { type: 'application/pdf' });
      setPDF(blob);
      setRowData(row);
      setModalOpen(true);
    } catch (error) {
      console.error('Error fetching student proof:', error);
      setModalOpen(false);
    }
  };

  const pickNext = (rows, excludeCode) =>
    rows.find((r) => r.code !== excludeCode && !skippedRef.current.has(r.code));

  const closeModal = () => {
    setModalOpen(false);
    setPDF(null);
    setRowData(null);
  };

  const handleResolved = async () => {
    // Refresh the menu badge count
    setReloadAdminBadges(reloadAdminBadges + 1);
    // Refresh the table data and pick the next pending row (excluding the one we just handled)
    const rows = await reloadData();
    const next = pickNext(rows, rowData?.code);
    if (next) {
      await loadStudent(next);
    } else {
      closeModal();
    }
  };

  const handleSkip = async () => {
    if (rowData?.code) skippedRef.current.add(rowData.code);
    const rows = await fetchStudents();
    const next = pickNext(rows, null);
    if (next) {
      await loadStudent(next);
    } else {
      closeModal();
    }
  };

  const columns = [
    { accessorKey: 'code', header: 'Code' },
    { accessorKey: 'name', header: 'Name' },
    { accessorKey: 'type', header: 'Type' },
    { accessorKey: 'email', header: 'Email' },
    { accessorKey: 'volunteer', header: 'Volunteer' },
    {
      id: 'actions',
      header: 'Validate',
      Cell: ({ row }) => (
        <button
          onClick={() => loadStudent(row.original)}
          style={{ padding: '6px 12px', border: '1px solid #ccc', borderRadius: '4px', background: '#f5f5f5', cursor: 'pointer' }}
        >
          Open
        </button>
      ),
    },
  ];

  return <>
    <div className="text-2xl mt-4 pb-4 font-bold flex gap-8 items-center">
      <GraduationCapIcon />
      Student Validations
    </div>

    <div style={{ flex: '1 1 0', paddingBottom: '20px' }}>
      <MaterialReactTable columns={columns} data={data} />
    </div>
    <StudentProofModal
      isOpen={modalOpen}
      onClose={() => setModalOpen(false)}
      pdf={pdf}
      row={rowData}
      onAccept={handleResolved}
      onDecline={handleResolved}
      onSkip={handleSkip}
    />
  </>;
};


export default UserTable;
